// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__37T05","info":"UpdateTermsInfo_info__3kPN0"};